module.exports = __webpack_public_path__ + "static/media/coin.f92533ba.svg";